module.exports = __webpack_public_path__ + "img/first-steps-2-min.304fb1ce.png";